import * as Cases from '../slices/casesSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import LinkedCaseListExpand from './linkedcaselistexpand';

const LinkedCaseListItem = (item: Cases.caseListState) => {
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const dispatch = useAppDispatch();

	const actionOnRow = (e: React.MouseEvent<HTMLElement>, item: Cases.caseListState) => {
		e.stopPropagation();
		dispatch(Cases.selectLinkedCase(item.caseno));
	}

	return (
		<div className="hover" key={item.caseno} style={{ padding: '4px 0', color: 'black', fontSize: 13 }} onClick={(e) => actionOnRow(e, item)}>
			<div style={{ alignItems: 'center' }} className="row100">
				<div className="flexGrow1" style={{ padding: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
					<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.caseno}</div>
				</div>
				<div className="flexGrow1" style={{ padding: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
					<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.type}</div>
				</div>
				<div className="flexGrow2" style={{ padding: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
					<div style={{ marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>{item.address}</div>
				</div>
			</div>
			<LinkedCaseListExpand {...item} />
		</div>
	);
}

export default LinkedCaseListItem;